// 工具函数
import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 引入五菱相关路由
import demandRoutes from '@/router/wuling/demand'
import bidRoutes from '@/router/wuling/bid'

export default [
  demandRoutes,

  ...bidRoutes,

  {
    path: 'WlToDoListAuditDetail',
    name: 'WlToDoListAuditDetail',
    type: menuTypeDict.MENU.value,
    meta: {
      title: '待办详情',
      layout: 'NavBarLayout',
      microName: 'wuling',
      hidden: true,
      isMicro: true
    },
    applicableCompanyTypes: companyTypeDict.array.map(company => company.value),
    platformAlias: [],
    applicableCompanyIdentities: workbenchServiceDict.array.map(
      service => service.value
    ),
    roles: [platformFunctionModuleDict.DEFAULT.right],
    superviseInstitutions: []
  }
]
